import React from 'react'

function AppWarningBage(props) {
    return (
        <div className={Object.className({
            "alert alert-warning custom_alert":true,
            [props.className||'']:true})
            } role="alert">
            <i className="fa fa-exclamation-circle"></i>
            {props.children}
        </div>
    )
}

export default AppWarningBage